export default {
  
  SET_USERS_REPORT (state, report) {
    state.usersReport = report
  },
  SET_USER_DATA (state, data) {
    state.userData = data
  },  
}
